(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/cookies-check-and-info/assets/javascripts/data-handler.js') >= 0) return;  svs.modules.push('/components/components/cookies-check-and-info/assets/javascripts/data-handler.js'); "use strict";

(function (svs) {
  'use strict';

  svs.components.cookies_check_and_info.DataHandler = function () {
    var thirdPartyCookie = 'consent';
    var showCookie = 'show-cookie-info';
    var cookieSeparator = ',';
    var cookieOptions = {
      daysToExist: 365,
      domain: svs.components.cookies_check_and_info.data.cookieDomain
    };

    function parseCookieData(cookie) {
      var inverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var tur = inverse ? true : false;
      var sport = inverse ? true : false;
      var vattendelaren = inverse ? true : false;
      var cookieArray = [];

      if (typeof cookie === 'string' && cookie.indexOf(cookieSeparator) !== -1) {
        cookieArray = cookie.split(cookieSeparator);
      }

      if (cookieArray.length === 3) {
        tur = cookieArray[0] === 't';
        sport = cookieArray[1] === 't';
        vattendelaren = cookieArray[2] === 't';
      }

      return {
        tur: tur,
        sport: sport,
        vattendelaren: vattendelaren
      };
    }

    function stringifyCookieData(data) {
      var response = [];

      if (data.tur) {
        response.push('t');
      } else {
        response.push('f');
      }

      if (data.sport) {
        response.push('t');
      } else {
        response.push('f');
      }

      if (data.vattendelaren) {
        response.push('t');
      } else {
        response.push('f');
      }

      return response.join(cookieSeparator);
    }

    function setUniqueCookieValue(cookieName, value) {
      var invert = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var currentValue = svs.utils.cookie.read(cookieName);
      var parsedValue = parseCookieData(currentValue, invert);

      if (svs.core.data.tenant === 'tb') {
        if (svs.components.cookies_check_and_info.isDivider()) {
          parsedValue.vattendelaren = value;
        } else {
          parsedValue.tur = value;
        }
      } else if (svs.core.data.tenant === 'lb') {
        parsedValue.sport = value;
      }

      var stringifiedValue = stringifyCookieData(parsedValue);
      svs.utils.cookie.set(cookieName, stringifiedValue, cookieOptions);
    }

    function getUniqueCookieValue(cookieName) {
      var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var cookieValue = decodeURIComponent(svs.utils.cookie.read(cookieName));
      var valueCookie = parseCookieData(cookieValue, invert);
      var returnValue = false;

      if (svs.core.data.tenant === 'tb') {
        if (svs.components.cookies_check_and_info.isDivider()) {
          returnValue = invert ? false : true;
        } else {
          returnValue = valueCookie.tur;
        }
      } else if (svs.core.data.tenant === 'lb') {
        returnValue = valueCookie.sport;
      }

      return returnValue;
    }

    return {
      setShowCookieInfo: function setShowCookieInfo(value) {
        setUniqueCookieValue(showCookie, value, true);
      },
      getShowCookieInfo: function getShowCookieInfo() {
        return getUniqueCookieValue(showCookie, true);
      },
      setThirdPartyCookieAccepted: function setThirdPartyCookieAccepted(value) {
        setUniqueCookieValue(thirdPartyCookie, value);
      },
      getThirdPartyCookieAccepted: function getThirdPartyCookieAccepted() {
        return getUniqueCookieValue(thirdPartyCookie);
      }
    };
  };

  svs.components.cookies_check_and_info.dataHandler = new svs.components.cookies_check_and_info.DataHandler();
})(svs);
 })(window);